module.exports = __webpack_public_path__ + "img/glsl-js-dark.dce5172c.svg";